import { ActionTypesFactory } from '../../../utils/utils';

export const GetEmployeesActionTypes = ActionTypesFactory('Employees', 'Get_Employees');